
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaCross } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ToggleButton } from 'primereact/togglebutton';
import { func } from 'prop-types';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const Clientmerger = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        client: '',
        month:'',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState(null);
    const [errors, setErrors] = useState({});
    const [newobjdata, setNewobj] = useState({});
    const [isclientmerge, setclientmerge] = useState(false);
     
    useEffect(()=>{
        getallclient();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));
    
        }catch(e){
            console.log(e);
        }
    };

    const validateForm2 = (formData) => {
        let valid = true;
        const newErrors = {};
        if (formData.client == '' || formData.client == undefined) {
          valid = false;
          newErrors.client = 'Field is required';
        }

        if (formData.month == '' || formData.month == undefined) {
            valid = false;
            newErrors.month = 'Field is required';
        }
        setErrors(newErrors);
       return valid; 
    }

    
    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm2(formData)){
              return; 
        }
        gettmclientlists();
    };

    const validateForm = (formData) => {
        let valid = true;
        const newErrors = {};
        if (formData.renameclient == '' || formData.renameclient == undefined) {
          valid = false;
        }

        if (formData.renamesubclient == '' || formData.renamesubclient == undefined) {
            valid = false;
        }
        
       return valid; 
    }

    const reject = () => {
    //    toast.current.show({ severity: 'warn', summary: 'Client merger', detail: 'Canceled', life: 3000 });
    }

    

    function replace(value){
        if(!validateForm(value)){
            toast.current.show({severity:'error', summary: "Client Merger validation", detail:`Client and subclient are required`, life: 3000}); 
             return;
        }
        value = JSON.stringify(value);
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Client merger',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: () => { 
                setclientmerge(true);
                timesheetService.renametmclientsubclient({formdata:value}).then((response)=>{
                if(response.status == 200){
                    toast.current.show({severity:'success', summary: "Client Merger", detail:`Replaced successfully!`, life: 3000}); 
                    setclientmerge(false);
                    gettmclientlists();
                }else{
                    toast.current.show({severity:'error', summary: "Client Merger", detail:`Not Replaced!`, life: 3000});   
                    setclientmerge(false);
                } 
            }).catch((error)=>{
                console.log(error);
                toast.current.show({severity:'error', summary: "Client Merger", detail:`Error`, life: 3000});   
                setclientmerge(false);
            }); },
           //  accept,
            reject
         });

       
    }

    function clientchnage(e,key,value){
       let obj = value;
       obj.renameclient = e.target.value;
       setNewobj((prevData) => ({...prevData,obj}));
    }

    function subclientchnage(e,key,value){
        let obj = value;
        obj.renamesubclient = e.target.value;
        setNewobj((prevData) => ({...prevData,obj}));
     }

     useEffect(()=>{
        // console.log(newobjdata);
        clientdisplay();
     },[datacomp]);

    function clientdisplay(){
        let emparr = [];
        datacomp.forEach((value,index)=>{
            // console.log(value.name);
            let checked = false;
            if(value.allowed == 'allowed'){
                checked = true; 
            }else{
                checked = false; 
            }

            emparr.push(<tr>
                 <td>{index + 1}</td>
                 <td>{value.client}</td>
                 <td>{value.subclient}</td>
                 <td>{value.timesheetscount}</td>
                 <td><span className='error'>Peplace with</span></td>
                 <td><input type="text" placeholder='client Newname or same' onChange={(e) => clientchnage(e,index,value)}/></td>
                 <td><input type="text" placeholder='subclient Newname'  onChange={(e) => subclientchnage(e,index,value)}/></td>
                 <td><button type='button' className='btn btn-success' onClick={() => replace(value)}><FaCheck/></button></td>
            </tr>);
        }); 

        return emparr;
    }

   

    function gettmclientlists(){
        try{
            let obj ={
                'client':formData.client,
                'month': formatterhelper.dateformatter({date:formData.month})  
            }; 
            obj = JSON.stringify(obj); 
            setloading(false);
           timesheetService.gettmclientlists({formdata:obj}).then((response)=>{
            // console.log("response"); 
            // console.log(response);
            if(response.status == 200){
                setDatacomp(response.data.data);
                setDatacomptemp(response.data.data);
                setloading(true);
            }else{
                setDatacomp([]);
                setDatacomptemp([]);
                setloading(true);
            }
           }).catch((error)=>{
             console.log(error);
             setDatacomp([]);
             setDatacomptemp([]);
             setloading(true);
           });

           
        }catch(e){
           console.log(e);
        //    setloading(true);
        }
    }

   

    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }


    function searchqaclient(e,type=''){
            let value = e.target.value; 
         
            if(type == ''){
                
                let _clientlist = datacomptemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                //  console.log(value);
                // console.log('this section');
                // return; 
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.client?.toLowerCase()) || searchRegexSubclient.test(item?.subclient?.toLowerCase()) || searchRegexSubclient.test(item?.date?.toLowerCase()) || searchRegexSubclient.test(item?.date?.toLowerCase())
                  || searchRegexSubclient.test(item?.name?.toLowerCase())      
                )
                );

                console.log(foundItems,'searched value');
    
                if (foundItems.length > 0) {
                    setDatacomp(foundItems);
                    // setclientallocation(foundItems);
                } else {
                    setDatacomp(datacomptemp);
                    // setclientallocation(clientallocationtemp);
                }      
            }else if(type=='clienttarget'){

                let _clientlist = datacomptemp;
                const searchRegexClient    = new RegExp(value.toLowerCase());
                const searchRegexSubclient = new RegExp(value.toLowerCase());
                const foundItems = _clientlist.filter(item => 
                //   (searchRegexClient.test(item.client) && searchRegexSubclient.test(item.subclient))
                (searchRegexClient.test(item?.client?.toLowerCase()) || searchRegexSubclient.test(item?.client?.toLowerCase())
              )
                );
    
                if (foundItems.length > 0) {
                    console.log('items found.');
                    // setClienttarget(foundItems);
                } else {
                    console.log('No items found.');
                    // setDatacomp([]);
                    // setClienttarget(clienttargettemp);
                }  

            }
            
            
    }

 return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog /> 
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
             <Dialog header="" visible={isclientmerge} style={{ width: '60vw' }} onHide={() => setclientmerge(false)}>
                 <h4 className='error text-center'>Renaming please wait!</h4>
             </Dialog>
            
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className='col-md-12'>
                <div className='row'>
                     <div className='col-md-12'>
                     <Message severity="info" text="Note:
Please ensure that during the process of renaming, certain considerations are taken into account:

1) While adding clients or subclients, please ensure they are present.
2) Please double-check spelling.
" />

                     
                     </div> 
                     <div className="col-md-4">
                   <br/>
                        <label className='pull-left'>Select Month</label>
                        <Calendar view="month" value={formData.month} name="month" onChange={handleChange} className='calender-custom-style custom-width-style' />
                        <br/>
                        {errors.month && <span className='error'>{errors.month}</span>}
                    </div>  
                   <div className="col-md-4">
                   <br/>
                        <label className='pull-left'>Client</label>
                        <br/>
                        <select className='custom-dropdown-style' name="client" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           {clientcomp}
                        </select>
                        {errors.client && <span className='error'>{errors.client}</span>}
                    </div>
                    
                    <div className="col-md-4 col-sm-4">
                      
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style col-md-12' />
                        </div>
                     </div>
                </div>
                <br/>
                <br/>

                
                <div className='col-md-2'>
                    <input type="text" className='form-control' placeholder='Search via Client & Subclient' onKeyUp={(e) => searchqaclient(e,'')}/>
                </div>
                <br></br>
               
                </div>
               
                </div>
                </form>
                <div className='col-md-12'>
                    <br/>
                    {!isloaded ? loader.Loadermd() : datacomp.length > 0 ?
                    (<table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Client</th>
                                <th scope="col" style={{width:'100px'}}>Subclient</th>
                                <th scope="col" style={{width:'20px'}}>No of Timesheet</th>
                                <th scope="col" style={{width:'25px'}}>--Replace with--</th>
                                <th scope="col">Client Rename</th>
                                <th scope="col">Subclient Rename</th>
                                <th scope="col">Action</th>  
                            </tr>
                        </thead>
                        <tbody>
                            {clientdisplay()}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                    </div>
                </div>
               
               
                <div className='row'>
                   
                   
                </div>
                <br/> 
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Clientmerger;
